// src/components/Footer.jsx
import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();

  const handleLinkClick = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const handleHomeClick = () => {
    if (window.location.pathname === '/') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    } else {
      navigate('/');
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="pot-castle-footer">
      {/* Wave Divider */}
      <div className="pot-castle-footer-wave">
        <svg viewBox="0 0 1440 120" fill="none" preserveAspectRatio="none">
          <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z" 
            fill="currentColor"/>
        </svg>
      </div>

      <div className="pot-castle-footer-content">
        <div className="pot-castle-container">
          {/* Main Footer Grid */}
          <div className="pot-castle-footer-grid">
            {/* Brand Section */}
            <div className="pot-castle-footer-section pot-castle-brand-section">
              <div className="pot-castle-brand-logo">
                <div className="pot-castle-logo-icon">
                  <svg className="pot-castle-castle-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 8L12 3L19 8L12 13L5 8Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M19 8V18H5V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M9 18V13H15V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M12 13V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <circle cx="12" cy="8" r="1" fill="currentColor"/>
                    <circle cx="8" cy="10" r="0.5" fill="currentColor"/>
                    <circle cx="16" cy="10" r="0.5" fill="currentColor"/>
                  </svg>
                </div>
                <div className="pot-castle-logo-text">
                  <span className="pot-castle-logo-name">POT CASTLE</span>
                  <span className="pot-castle-logo-tagline">Premium Cannabis Dispensary</span>
                </div>
              </div>
              
              <p className="pot-castle-brand-description">
                Washington DC's premium cannabis delivery service. 
                Fast, discreet, and professional. Lab-tested products 
                delivered to your door within 30-45 minutes.
              </p>

              <div className="pot-castle-social-links">
                <a 
                  href="https://instagram.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="pot-castle-social-link"
                  aria-label="Instagram"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                    <circle cx="12" cy="12" r="4"/>
                    <circle cx="17.5" cy="6.5" r="1.5"/>
                  </svg>
                </a>
                <a 
                  href="https://facebook.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="pot-castle-social-link"
                  aria-label="Facebook"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                  </svg>
                </a>
                <a 
                  href="https://twitter.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="pot-castle-social-link"
                  aria-label="Twitter"
                >
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"/>
                  </svg>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="pot-castle-footer-section">
              <h4 className="pot-castle-footer-title">
                <span className="pot-castle-title-decoration"></span>
                Quick Links
              </h4>
              <nav className="pot-castle-footer-nav">
                <button onClick={handleHomeClick} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Home
                </button>
                <button onClick={() => handleLinkClick('/products')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Products
                </button>
                <button onClick={() => handleLinkClick('/categories')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Categories
                </button>
                <button onClick={() => handleLinkClick('/about')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  About Us
                </button>
              </nav>
            </div>

            {/* Shop Categories */}
            <div className="pot-castle-footer-section">
              <h4 className="pot-castle-footer-title">
                <span className="pot-castle-title-decoration"></span>
                Shop Categories
              </h4>
              <nav className="pot-castle-footer-nav">
                <button onClick={() => handleLinkClick('category/Flower')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Flower
                </button>
                <button onClick={() => handleLinkClick('/category/Exotic-Flower')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Exotic Flower
                </button>
                <button onClick={() => handleLinkClick('/category/Edibles')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Edibles
                </button>
                <button onClick={() => handleLinkClick('/category/Concentrates')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Concentrates
                </button>
                <button onClick={() => handleLinkClick('/category/disposable-cart')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Vapes & Carts
                </button>
                <button onClick={() => handleLinkClick('/category/Pre-rolls')} className="pot-castle-footer-link">
                  <span className="pot-castle-link-dot"></span>
                  Pre-rolls
                </button>
              </nav>
            </div>

            {/* Contact & Hours */}
            <div className="pot-castle-footer-section">
              <h4 className="pot-castle-footer-title">
                <span className="pot-castle-title-decoration"></span>
                Contact Us
              </h4>
              
              <div className="pot-castle-contact-info">
                <a href="tel:2022764975" className="pot-castle-contact-item">
                  <div className="pot-castle-contact-icon">📞</div>
                  <div className="pot-castle-contact-details">
                    <span className="pot-castle-contact-label">Call Us</span>
                    <span className="pot-castle-contact-value">(202) 276-4975</span>
                  </div>
                </a>

                <a href="sms:2022764975" className="pot-castle-contact-item">
                  <div className="pot-castle-contact-icon">💬</div>
                  <div className="pot-castle-contact-details">
                    <span className="pot-castle-contact-label">Text Us</span>
                    <span className="pot-castle-contact-value">(202) 276-4975</span>
                  </div>
                </a>

                <a href="mailto:info@potcastle.com" className="pot-castle-contact-item">
                  <div className="pot-castle-contact-icon">📧</div>
                  <div className="pot-castle-contact-details">
                    <span className="pot-castle-contact-label">Email Us</span>
                    <span className="pot-castle-contact-value">info@potcastle.com</span>
                  </div>
                </a>

                <div className="pot-castle-contact-item">
                  <div className="pot-castle-contact-icon">📍</div>
                  <div className="pot-castle-contact-details">
                    <span className="pot-castle-contact-label">Location</span>
                    <span className="pot-castle-contact-value">Washington, DC</span>
                  </div>
                </div>
              </div>

              <div className="pot-castle-hours-info">
                <h5 className="pot-castle-hours-title">Hours of Operation</h5>
                <div className="pot-castle-hours-grid">
                  <div className="pot-castle-hours-row">
                    <span>Monday - Sunday</span>
                    <span>9:00 AM - 10:00 PM</span>
                  </div>
                </div>
                <p className="pot-castle-delivery-note">
                  🚚 Average Delivery 30-45 Min • Discreet Packaging
                </p>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="pot-castle-footer-bottom">
            <div className="pot-castle-bottom-content">
              <p className="pot-castle-copyright">
                © {currentYear} Pot Castle. All rights reserved.
              </p>
              
              <div className="pot-castle-legal-links">
                <button onClick={() => handleLinkClick('/privacy')} className="pot-castle-legal-link">
                  Privacy Policy
                </button>
                <span className="pot-castle-separator">•</span>
                <button onClick={() => handleLinkClick('/terms')} className="pot-castle-legal-link">
                  Terms of Service
                </button>
                <span className="pot-castle-separator">•</span>
                <button onClick={() => handleLinkClick('/faq')} className="pot-castle-legal-link">
                  FAQ
                </button>
              </div>
            </div>
            
            <p className="pot-castle-age-warning">
              ⚠️ Must be 21+ with valid government-issued photo ID. Consume responsibly.
            </p>
          </div>
        </div>
      </div>

      <style>{`
        /* Pot Castle Footer Styles */
        .pot-castle-footer {
          position: relative;
          background: linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%);
          color: white;
          margin-top: auto;
          overflow: hidden;
        }

        /* Wave Divider */
        .pot-castle-footer-wave {
          position: absolute;
          top: -1px;
          left: 0;
          right: 0;
          line-height: 0;
          transform: translateY(-99%);
        }

        .pot-castle-footer-wave svg {
          width: 100%;
          height: clamp(40px, 8vw, 80px);
          color: var(--background, #ffffff);
        }

        /* Footer Content */
        .pot-castle-footer-content {
          position: relative;
          padding: clamp(2rem, 6vw, 4rem) 0 clamp(1.5rem, 4vw, 2rem);
          z-index: 2;
        }

        .pot-castle-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 0 clamp(1rem, 4vw, 2rem);
        }

        /* Footer Grid */
        .pot-castle-footer-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(min(100%, 250px), 1fr));
          gap: clamp(2rem, 5vw, 3rem);
          margin-bottom: clamp(2rem, 5vw, 3rem);
        }

        /* Brand Section */
        .pot-castle-brand-section {
          grid-column: span 1;
        }

        @media (min-width: 1024px) {
          .pot-castle-brand-section {
            grid-column: span 2;
          }
        }

        .pot-castle-brand-logo {
          display: flex;
          align-items: center;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        .pot-castle-logo-icon {
          width: clamp(3rem, 6vw, 3.5rem);
          height: clamp(3rem, 6vw, 3.5rem);
          background: linear-gradient(135deg, #8b5cf6, #ec489a);
          border-radius: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
        }

        .pot-castle-castle-icon {
          width: clamp(1.5rem, 3vw, 1.75rem);
          height: clamp(1.5rem, 3vw, 1.75rem);
          color: white;
        }

        .pot-castle-logo-text {
          display: flex;
          flex-direction: column;
        }

        .pot-castle-logo-name {
          font-size: clamp(1.25rem, 3vw, 1.5rem);
          font-weight: 800;
          background: linear-gradient(135deg, #8b5cf6, #ec489a);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          line-height: 1.2;
        }

        .pot-castle-logo-tagline {
          font-size: 0.75rem;
          opacity: 0.8;
          letter-spacing: 0.05em;
        }

        .pot-castle-brand-description {
          color: rgba(255, 255, 255, 0.8);
          line-height: 1.6;
          margin-bottom: 1.5rem;
          font-size: 0.95rem;
          max-width: 400px;
        }

        /* Social Links */
        .pot-castle-social-links {
          display: flex;
          gap: 1rem;
        }

        .pot-castle-social-link {
          width: 2.5rem;
          height: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
          color: white;
          transition: all 0.3s ease;
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .pot-castle-social-link:hover {
          background: linear-gradient(135deg, #8b5cf6, #ec489a);
          transform: translateY(-3px);
          border-color: transparent;
        }

        .pot-castle-social-link svg {
          width: 1.2rem;
          height: 1.2rem;
        }

        /* Footer Titles */
        .pot-castle-footer-title {
          font-size: clamp(1rem, 2.5vw, 1.125rem);
          font-weight: 700;
          margin-bottom: 1.5rem;
          position: relative;
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .pot-castle-title-decoration {
          width: 3px;
          height: 1.5rem;
          background: linear-gradient(135deg, #8b5cf6, #ec489a);
          border-radius: 3px;
        }

        /* Footer Navigation */
        .pot-castle-footer-nav {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .pot-castle-footer-link {
          background: none;
          border: none;
          color: rgba(255, 255, 255, 0.8);
          text-align: left;
          padding: 0.25rem 0;
          cursor: pointer;
          font-family: inherit;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 0.5rem;
          width: 100%;
        }

        .pot-castle-footer-link:hover {
          color: white;
          transform: translateX(4px);
        }

        .pot-castle-link-dot {
          width: 6px;
          height: 6px;
          background: linear-gradient(135deg, #8b5cf6, #ec489a);
          border-radius: 50%;
          transition: all 0.3s ease;
        }

        .pot-castle-footer-link:hover .pot-castle-link-dot {
          transform: scale(1.5);
        }

        /* Contact Info */
        .pot-castle-contact-info {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
        }

        .pot-castle-contact-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          text-decoration: none;
          color: rgba(255, 255, 255, 0.9);
          transition: all 0.3s ease;
          padding: 0.75rem;
          border-radius: 0.75rem;
          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }

        .pot-castle-contact-item:hover {
          background: rgba(139, 92, 246, 0.2);
          transform: translateX(4px);
          border-color: rgba(139, 92, 246, 0.3);
        }

        .pot-castle-contact-icon {
          font-size: 1.25rem;
        }

        .pot-castle-contact-details {
          display: flex;
          flex-direction: column;
        }

        .pot-castle-contact-label {
          font-size: 0.7rem;
          opacity: 0.7;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .pot-castle-contact-value {
          font-size: 0.9rem;
          font-weight: 500;
        }

        /* Hours Info */
        .pot-castle-hours-info {
          background: linear-gradient(135deg, rgba(139, 92, 246, 0.1), rgba(236, 72, 153, 0.1));
          border-radius: 1rem;
          padding: 1rem;
          border: 1px solid rgba(139, 92, 246, 0.2);
        }

        .pot-castle-hours-title {
          font-size: 0.85rem;
          font-weight: 600;
          margin-bottom: 0.75rem;
          opacity: 0.9;
          color: #8b5cf6;
        }

        .pot-castle-hours-grid {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          margin-bottom: 0.75rem;
        }

        .pot-castle-hours-row {
          display: flex;
          justify-content: space-between;
          font-size: 0.85rem;
          color: rgba(255, 255, 255, 0.9);
        }

        .pot-castle-delivery-note {
          font-size: 0.75rem;
          color: #10b981;
          background: rgba(16, 185, 129, 0.1);
          padding: 0.5rem;
          border-radius: 0.5rem;
          text-align: center;
          font-weight: 600;
        }

        /* Footer Bottom */
        .pot-castle-footer-bottom {
          border-top: 1px solid rgba(255, 255, 255, 0.2);
          padding-top: 1.5rem;
          text-align: center;
        }

        .pot-castle-bottom-content {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          gap: 1rem;
          margin-bottom: 1rem;
        }

        @media (max-width: 640px) {
          .pot-castle-bottom-content {
            flex-direction: column;
            text-align: center;
          }
        }

        .pot-castle-copyright {
          color: rgba(255, 255, 255, 0.7);
          font-size: 0.85rem;
        }

        .pot-castle-legal-links {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 0.5rem;
          justify-content: center;
        }

        .pot-castle-legal-link {
          background: none;
          border: none;
          color: rgba(255, 255, 255, 0.7);
          cursor: pointer;
          font-family: inherit;
          font-size: 0.85rem;
          transition: all 0.3s ease;
          padding: 0.25rem 0.5rem;
        }

        .pot-castle-legal-link:hover {
          color: #8b5cf6;
        }

        .pot-castle-separator {
          color: rgba(255, 255, 255, 0.4);
        }

        .pot-castle-age-warning {
          color: rgba(255, 255, 255, 0.6);
          font-size: 0.75rem;
          max-width: 600px;
          margin: 0 auto;
        }

        /* Mobile Responsive */
        @media (max-width: 768px) {
          .pot-castle-footer-grid {
            grid-template-columns: 1fr;
          }

          .pot-castle-brand-section {
            grid-column: span 1;
          }

          .pot-castle-brand-description {
            max-width: 100%;
          }

          .pot-castle-contact-item {
            padding: 0.75rem;
          }
        }

        @media (max-width: 480px) {
          .pot-castle-hours-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.25rem;
          }

          .pot-castle-legal-links {
            flex-direction: column;
            gap: 0.5rem;
          }

          .pot-castle-separator {
            display: none;
          }
        }

        /* Dark Mode Support */
        @media (prefers-color-scheme: dark) {
          .pot-castle-footer {
            background: linear-gradient(135deg, #0a0a0a 0%, #1a0b2e 100%);
          }
        }

        /* Touch Device Optimizations */
        @media (hover: none) {
          .pot-castle-footer-link:hover,
          .pot-castle-contact-item:hover,
          .pot-castle-social-link:hover {
            transform: none;
          }

          .pot-castle-footer-link:active,
          .pot-castle-contact-item:active {
            background: rgba(139, 92, 246, 0.2);
          }
        }

        /* Reduced Motion */
        @media (prefers-reduced-motion: reduce) {
          * {
            animation-duration: 0.01ms !important;
            transition-duration: 0.01ms !important;
          }
        }

        /* Print Styles */
        @media print {
          .pot-castle-footer {
            background: #f0f0f0;
            color: black;
          }

          .pot-castle-footer-wave,
          .pot-castle-social-links {
            display: none;
          }
        }
      `}</style>
    </footer>
  );
};

export default Footer;